/**
 * The retired salary comparison tool URLs. These must return 410 Gone and stay out of sitemaps.
 * Vike routing uses English logical path `/salary-comparison` for all locales (see +onBeforeRoute).
 */
export const REMOVED_SALARY_COMPARISON_URL_LOGICAL = '/salary-comparison' as const;

const REMOVED_SEGMENT_BY_LOCALE = {
  en: 'salary-comparison',
  fi: 'palkkavertailu',
  sv: 'lonerjamforelse',
} as const;

const REMOVED_SEGMENT_SET = new Set<string>(Object.values(REMOVED_SEGMENT_BY_LOCALE));

function normalizePathname(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/$/, '') || '/';
}

/**
 * Path after locale prefix, e.g. `/salary-comparison` or `/palkkavertailu`.
 */
export function isRemovedSalaryComparisonPathnameWithoutLocale(pathnameWithoutLocale: string): boolean {
  const p = normalizePathname(pathnameWithoutLocale);
  if (p === '/') return false;
  const segment = p.slice(1);
  return REMOVED_SEGMENT_SET.has(segment);
}

/**
 * Full public URL path including locale, e.g. `/en/salary-comparison`.
 */
export function isRemovedSalaryComparisonPublicUrl(pathname: string): boolean {
  const p = normalizePathname(pathname);
  const m = p.match(/^\/(en|fi|sv)\/([^/]+)$/);
  if (!m) return false;
  return REMOVED_SEGMENT_SET.has(m[2]);
}
